var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.isEdit ? "编辑预警模块" : "新增预警模块",
            top: "80px",
            width: "600px",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.pram,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模块KEY：", prop: "moduleKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isEdit,
                      clearable: "",
                      placeholder: "如：ORDER_PAY, USER_LOGIN",
                    },
                    model: {
                      value: _vm.pram.moduleKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "moduleKey", $$v)
                      },
                      expression: "pram.moduleKey",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("用于代码关联，创建后不可修改"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模块名称：", prop: "moduleName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入模块名称" },
                    model: {
                      value: _vm.pram.moduleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "moduleName", $$v)
                      },
                      expression: "pram.moduleName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "包路径：", prop: "packagePrefix" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "如：com.zbkj.service.service.impl.Order",
                    },
                    model: {
                      value: _vm.pram.packagePrefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "packagePrefix", $$v)
                      },
                      expression: "pram.packagePrefix",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("用于异常堆栈匹配，支持前缀匹配"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "影响范围：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      resize: "none",
                      placeholder: "描述该模块异常会影响的业务范围",
                    },
                    model: {
                      value: _vm.pram.impactScope,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "impactScope", $$v)
                      },
                      expression: "pram.impactScope",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开发负责人：", prop: "devUserIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "选择开发负责人（支持多选）",
                      },
                      model: {
                        value: _vm.pram.devUserIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "devUserIds", $$v)
                        },
                        expression: "pram.devUserIds",
                      },
                    },
                    _vm._l(_vm.adminList, function (admin) {
                      return _c("el-option", {
                        key: admin.id,
                        attrs: {
                          label:
                            admin.realName +
                            "（" +
                            (admin.phone || "无手机号") +
                            "）",
                          value: admin.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "测试负责人：", prop: "testUserIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "选择测试负责人（支持多选）",
                      },
                      model: {
                        value: _vm.pram.testUserIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "testUserIds", $$v)
                        },
                        expression: "pram.testUserIds",
                      },
                    },
                    _vm._l(_vm.adminList, function (admin) {
                      return _c("el-option", {
                        key: admin.id,
                        attrs: {
                          label:
                            admin.realName +
                            "（" +
                            (admin.phone || "无手机号") +
                            "）",
                          value: admin.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "启用状态：", prop: "enabled" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.pram.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "enabled", $$v)
                      },
                      expression: "pram.enabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }